export default "__VITE_ASSET__dee778a5__"